import React, { MouseEvent } from 'react';
import { ReactSVG } from 'react-svg';

import LockIconImage from '../images/lock.svg';

interface CertIconProps {
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
}

const LockIcon = (props: CertIconProps) => {
  return (
    <ReactSVG
      src={LockIconImage}
    />
  )
}

export default LockIcon;
